import { Extensions } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { TaskItem, TaskList } from '@tiptap/extension-list';
import { TableKit } from '@tiptap/extension-table';
import { Markdown } from '@tiptap/markdown';
import StarterKit from '@tiptap/starter-kit';

// Shared by the editor and the HTML renderer, so anything a note can display it can also keep when edited and saved.
// Tables, images and task lists have no toolbar buttons, but existing content uses them and must survive a save.
export function createRichTextExtensions(): Extensions {
  return [
    // Links aren't followed while editing, typed domains aren't turned into links (so saved notes only change
    // when someone adds a link), and Tiptap's link validation rejects javascript: and similar URLs.
    // Underline is off because markdown has no underline syntax; Tiptap would save it as non-standard ++text++.
    StarterKit.configure({
      link: { openOnClick: false, autolink: false, defaultProtocol: 'https' },
      underline: false,
    }),
    TableKit,
    Image,
    TaskList,
    TaskItem.configure({ nested: true }),
    Markdown,
  ];
}
